import home from "@/api/home";
import categories from "@/api/categories";

const state = {
  allCats: "",
  search: "",
  output: [],
};

const mutations = {
  input(state, input) {
    state.allCats = input;
  },
  searching(state, input) {
    state.search = input;
  },
};

const actions = {
  allCategories({ commit }) {
    home.allCategories().then((res) => {
      commit("input", res.data);
    });
  },
  searchInCats({ commit, state }, search) {
    categories.searchInputCategory({ search }).then((res) => {
      let items = res.data;
      state.output = items;
      commit("searching", search);
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
